import React from 'react';

import mixpanel from '~/components/CmsMain/mixpanel';
import { FNOL_MIXPANEL_EVENTS } from '~/pocs/mixpanel';

import ConfigurationPage, { InternalConfiguration } from '../IncidentConfigurationPage/ConfigurationPage';
import type { IncidentConfigurationSummary } from '../IncidentConfigurationPage/types';

import copies from './FnolConfigurationScreen/copies.json';
import FnolConfigurationScreen from './FnolConfigurationScreen/FnolConfigurationScreen';
import FnolMandatoryFieldsAsteriskSwitch from './FnolMandatoryFieldsAsteriskSwitch';

const trackMixpanelEvent = (IncidentConfiguration: IncidentConfigurationSummary) => {
  mixpanel.track(FNOL_MIXPANEL_EVENTS.EDIT_FNOL_CONFIGURATION_CLICKED, {
    incident_configuration_id: IncidentConfiguration?.id,
    sub_organization_id: IncidentConfiguration?.sub_organization_id,
  });
};

const FnolConfiguration: React.FC = () => {
  return (
    <ConfigurationPage
      configurationTitle="FNOL Configuration"
      configurationSubtitle={copies.configuration_subtitle}
      externalAdminRoute="/fnol_configuration"
      ConfigurationScreen={FnolConfigurationScreen}
      searchPlaceholder="Search FNOL"
      counterSuffix="FNOLs"
      displayName="FNOL Name"
      trackMixpanelEvent={trackMixpanelEvent}
      displayFNOLInboxCols={true}
      headerSlot={<FnolMandatoryFieldsAsteriskSwitch />}
    />
  );
};

const InternalFnolConfiguration: React.FC = () => {
  return (
    <div className="absolute inset-0 overflow-scroll">
      <InternalConfiguration
        configurationTitle="FNOL Configuration"
        configurationSubtitle={copies.configuration_subtitle}
        externalAdminRoute="/fnol_configuration"
        ConfigurationScreen={FnolConfigurationScreen}
        searchPlaceholder="Search FNOL"
        counterSuffix="FNOLs"
        displayName="FNOL Name"
        trackMixpanelEvent={trackMixpanelEvent}
        displayFNOLInboxCols={true}
        displayPostFnolHook={true}
        isInternalAdmin={true}
        headerSlot={<FnolMandatoryFieldsAsteriskSwitch />}
      />
    </div>
  );
};

export { InternalFnolConfiguration };
export default FnolConfiguration;
